import { gql } from '@apollo/client'

export const GET_ALL_CITIZENS_MUTATIONS = gql`
  mutation GetAllProcessesCitizensMutation(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllProcessesCitizensMutation(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        email
        name
        last_name
        phone
        address_full
        coordinates
        address
      }
    }
  }
`
